module.exports = __webpack_public_path__ + "img/flappy.91fcb09.svg";